import { render, staticRenderFns } from "./CasualsPhoneBook.vue?vue&type=template&id=5d8a2050&"
import script from "./CasualsPhoneBook.vue?vue&type=script&lang=js&"
export * from "./CasualsPhoneBook.vue?vue&type=script&lang=js&"
import style0 from "./CasualsPhoneBook.vue?vue&type=style&index=0&id=5d8a2050&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports